module.exports = __webpack_public_path__ + "static/img/ts_case_pic1.749c737.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ts_case_pic1.jpg
// module id = zjKR
// module chunks = 1